import { InjectionToken } from '@angular/core';

export const HX_DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';

export const HX_DATE_FORMAT = new InjectionToken<string>(HX_DEFAULT_DATE_FORMAT);
